import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import Select from 'react-select';

export default ({InfIdUse, InfIdConta,  IdUse, ListContasTel, DadCont, IdConta, ListContas, setAddList, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo}) => {

const [Titulo, setTitulo] = useState("Criar Exercicio");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [ListCat, setListCat] = useState([]);
const [Nome, setNome] = useState("");
const [Conta, setConta] = useState("");
const [Categoria, setCategoria] = useState("");
const [IdCategoria, setIdCategoria] = useState("");
const [TempoAtivo, setTempoAtivo] = useState(false);
const [BenefAtivo, setBenefAtivo] = useState(true);
const [FazerAtivo, setFazerAtivo] = useState(true);
const [MuscuAtivo, setMuscuAtivo] = useState(true);
const [Ativo, setAtivo] = useState(true);
const [Img1, setImg1] = useState("../assets/avatarimg.png");
const [Imgs1, setImgs1] = useState("");
const [Img2, setImg2] = useState("../assets/avatarimg.png");
const [Imgs2, setImgs2] = useState("");
const [Beneficios, setBeneficios] = useState("");
const [ComoFazer, setComoFazer] = useState("");
const [ContasNome, setContasNome] = useState("Geral");
const [ContasTel, setContasTel] = useState("Geral");
const [IdContRes, setIdContRes] = useState(IdConta);


   useEffect(() => {
         listandoCat();     
        }, [IdContRes])
  

 const handleToggle1 = () => {
    setTempoAtivo(!TempoAtivo);
  };
  const handleToggle2 = () => {
    setBenefAtivo(!BenefAtivo);
  };
  const handleToggle3 = () => {
    setFazerAtivo(!FazerAtivo);
  };
  const handleToggle4 = () => {
    setMuscuAtivo(!MuscuAtivo);
  };
  const handleToggle5 = () => {
    setAtivo(!Ativo);
  };


  const criando = ()=>{
  if(IdCategoria !== ""  ){
    if(Nome !=="" && Nome !==" " && Nome !=="  " && Nome !=="   " && Nome !=="    " && Nome !=="     " && Nome !=="      "
    && Nome !=="       " && Nome !=="        " && Nome !=="         " && Nome !=="          " 
    && Nome !=="           " ){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true)     
        Api.TACriarExercicio(DadCont, InfIdUse, InfIdConta, IdConta,  IdUse, Categoria, Dados, Nome, IdContRes, IdCategoria, Ativo, TempoAtivo, BenefAtivo, FazerAtivo, MuscuAtivo, Imgs1,  Imgs2, Beneficios, ComoFazer,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList);
 
       
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("Preencha o Nome do Exercício")
    }
    } else {
        setMsgErro("Escolha a Categoria")
    }
    
  }


  const listandoCat = ()=>{
              Api.TAListdeCat(Dados, IdContRes, setListCat);
            }
 const ColocarImg1 = (e)=>{
    const reader = new FileReader()
    reader.onload = () => {
      if(reader.readyState === 2) {
        setImg1(reader.result);
      }
    }
   reader.readAsDataURL(e.target.files[0]);
    setImgs1(e.target.files[0]);
  }
  const ExcImg1 = ()=>{
   
    setImgs1("");
    setImg1("../assets/avatarimg.png");
  }

  const ColocarImg2 = (e)=>{
    const reader = new FileReader()
    reader.onload = () => {
      if(reader.readyState === 2) {
        setImg2(reader.result);
      }
    }
   reader.readAsDataURL(e.target.files[0]);
    setImgs2(e.target.files[0]);
  }
  const ExcImg2 = ()=>{
   
    setImgs2("");
    setImg2("../assets/avatarimg.png");
  }

  const printValue1 = (target) => {
      // console.log(target)
      // for(let i in ListContas){
       
      //   if(ListContas[i].select === target.value){
      //    setConta(ListContas[i].id)
      //   }
      
      // }
     
      
        }

        const printValue2 = (target) => {
          setCategoria(target.label)
          setIdCategoria(target.value)
        }

         const printValue5 = (target) => {
        
           setIdContRes(target.value)
           setContasNome(target.label)
           setContasTel(target.Tel)
           }
           const printValue6 = (target) => {
            
           setIdContRes(target.value)
           setContasNome(target.Nome)
           setContasTel(target.label)
           }

        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="fas fa-dumbbell" /> Exercício  
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                    <div className="col-12">
                        <Butao 
                        style={"btn .btn-sm btn-info"}
                        titulo={"Salvar"}
                        onClick={()=>criando()}
                        />  
                    </div><br />
                    
                     {MsgErro !== "" &&
                    <>
                    <div class="alert alert-danger alert-dismissible">
                  
                  <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                  {MsgErro}
                </div>
                   
                    </>
                    }
                    </>
                    }
                    
                  
                    
                    <strong>Digite o Nome do Exercício</strong><br />
                    <div className="input_cadatro">
                             
                                <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Digite o Nome do Exercicio " 
                                value={Nome}
                                onChange={t=>setNome(t.target.value)}
                              />

                            </div> 
                    <br />
                        
                    
                   
                       
                     {DadCont === "Emp" &&
                                                   <>
                        <strong>Contas</strong><br />   
                        {ListContas.length !== 0 &&
                        <>
                    
                    <div  style={{width:250, marginBottom:10, marginLeft:5}}>
                      <Select
                        defaultValue={ContasNome}
                      onChange={(target) => printValue5(target)}
                      options={ListContas}
                      placeholder={"Escolha  o Nome "}
                    />    
                    
                  </div> 
                    <div  style={{width:250, marginBottom:10, marginLeft:5}}>
                      <Select
                        defaultValue={ContasTel}
                      onChange={(target) => printValue6(target)}
                      options={ListContasTel}
                      placeholder={"Escolha  o Telefone"}
                    />    
                    
                  </div> 
                  <string style={{marginBottom:10, marginLeft:5}}>Id: {IdContRes} </string><br />
                  <string style={{marginBottom:10, marginLeft:5}}>Cliente: {ContasNome} </string><br />
                   <string style={{marginBottom:10, marginLeft:5}}>Tel: {ContasTel}</string> 
                  </>
                      }
                        </>
      
                              }
                  <br />
                         
      
                     {ListCat.length !== 0 &&
                     <>
                     <strong>Categoria do Exercício</strong><br />
                          <div className="input_cadatro">                       
                         <Select
                          defaultValue={Categoria}
                          onChange={(target) => printValue2(target)}
                          options={ListCat}
                          placeholder={"Escolha  a Categoria "}
                        />   
                          </div>  
                          
                     </>

                     } 
                  
                 <div style={{ textAlign: "center", marginTop: "30px" }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle1}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: TempoAtivo ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: TempoAtivo ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {TempoAtivo ? "Tempo Ativo" : "Tempo Desativado"}
                          </span>
                        </label>
                      </div>
                   
                     
                  </address>
                    </div>
                      <div className="col-sm-4 invoice-col">
                    <address>
                   
                    <strong>Gif do Treino:</strong><br />
                    <div className="FotosArqui" >
                    <div className="FotoQuaAnun" >
                      {Img1 === "../assets/avatarimg.png" ?
                         <img src={Img1} alt="imagem" className="FotoQua2" />
                      :
                      <img src={Img1} alt="imagem" className="FotoQua1" />
                      }
                   
                    </div>
                  
                 
                  

                    {Imgs1 === "" ?
                     <div class="input-group">
                     <input type="file"
                     accept="image/*"
                     className="Arquivos"
                     onChange={(e)=>ColocarImg1(e)} 
                     />
                   </div>
                    :
                    <div className="row no-print">
                   <div className="col-12">
                  <Butao 
                   style={"btn .btn-sm btn-danger"}
                   titulo={"Excluir"}
                   onClick={()=>ExcImg1()}
                   />  
                   </div>
                   </div>

                    } 
                   
                   

                   </div>
                   <div style={{ textAlign: "center", marginTop: "30px" }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle5}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: Ativo ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: Ativo ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {Ativo ? "Exercício Ativo" : "Exercício Desativado"}
                          </span>
                        </label>
                      </div> 
                   <div style={{ textAlign: "center", marginTop: "30px" }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle4}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: MuscuAtivo ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: MuscuAtivo ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {MuscuAtivo ? "Músculo Ativo" : "Músculo Desativado"}
                          </span>
                        </label>
                      </div>  
                       
                    </address>
                   </div>
                    <div className="col-sm-4 invoice-col">
                    <address>
                     
                    <strong>imagem dos Músculos:</strong><br />
                    <div className="FotosArqui" >
                    <div className="FotoQuaAnun" >
                      {Img2 === "../assets/avatarimg.png" ?
                         <img src={Img2} alt="imagem" className="FotoQua2" />
                      :
                      <img src={Img2} alt="imagem" className="FotoQua1" />
                      }
                   
                    </div>
                  
                 
                  

                    {Imgs2 === "" ?
                     <div class="input-group">
                     <input type="file"
                     accept="image/*"
                     className="Arquivos"
                     onChange={(e)=>ColocarImg2(e)} 
                     />
                   </div>
                    :
                    <div className="row no-print">
                   <div className="col-12">
                  <Butao 
                   style={"btn .btn-sm btn-danger"}
                   titulo={"Excluir"}
                   onClick={()=>ExcImg2()}
                   />  
                   </div>
                   </div>

                    } 

                   </div>
                         
                      <div style={{ textAlign: "center", marginTop: "30px" }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle2}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: BenefAtivo ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: BenefAtivo ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {BenefAtivo ? "Banefícios Ativo" : "Benefícios Desativado"}
                          </span>
                        </label>
                      </div> 
                      <div style={{ textAlign: "center", marginTop: "30px" }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle3}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: FazerAtivo ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: FazerAtivo ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {FazerAtivo ? "Como Fazer Ativo" : "Como Fazer Desativado"}
                          </span>
                        </label>
                      </div>  
                    </address>
                   </div>
              </div>
              <div className="row no-print">
             
               
              
              </div>
              
                       
              <strong>Digite os Benefícios:</strong><br />
                    <div className="input_cadatro">
                            <textarea 
                              rows={10}
                              type="text" 
                              className="form-control" 
                              placeholder="Digite os Benefícios"
                              value={Beneficios}
                              onChange={t=>setBeneficios(t.target.value)}
                              maxlength="5100"
                                />

                         </div> 
                    <br /> 
                     <strong>Digite Como Fazer o Exercício:</strong><br />
                    <div className="input_cadatro">
                            <textarea 
                              rows={10}
                              type="text" 
                              className="form-control" 
                              placeholder="Digite Como Fazer o Exercício"
                              value={ComoFazer}
                              onChange={t=>setComoFazer(t.target.value)}
                              maxlength="5100"
                                />

                         </div> 
                    <br />        
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}